<div
  data-testid="shop-navigate-banner"
  class="tw-px-4"
  role="button"
  tabindex="0"
  (click)="navigateToShopSection()"
>
  <div class="tw-bg-white tw-flex tw-justify-between tw-items-center tw-rounded-3 tw-shadow-z13">
    <div class="tw-py-[13px] tw-pl-[14px]">
      <p i18n="@@shopNavigateBannerTitle" class="tw-capitalize tw-font-lexend tw-text-300 tw-font-extrabold tw-mb-2.5 tw-pr-2">
        our skin, hair &amp; body care essentials
      </p>
      <button
        csButton
        size="small"
        class="tw-min-w-fit tw-w-fit tw-px-3 tw-pl-4"
        style="margin: 0 !important;"
        (click)="$event.stopPropagation(); navigateToShopSection()"
      >
        <span i18n="@@shopNavigateBannerCta" class="tw-text-300 tw-font-semibold">See Products</span>
      </button>
    </div>
    <div class="tw-max-w-[153px]">
      <img src="/assets/images/products.png" alt="products" />
    </div>
  </div>
</div>


